<!-- <div class="p-6 bg-gray-50 min-h-screen">
  <div class="flex flex-wrap gap-4 mb-6 items-end">
    
    <div class="flex-1 min-w-[200px]">
      <mat-form-field  class="w-full">
        <mat-label>Search Scheme Name</mat-label>
        <input matInput (keyup)="applyFilter($event)" placeholder="Search..." />
      </mat-form-field>
    </div>

    <div class="min-w-[200px]">
      <mat-form-field  class="w-full">
        <mat-label>Status</mat-label>
        <mat-select (selectionChange)="onStatusChange($event)">
          <mat-option value="">All</mat-option>
          <mat-option value="active">Active</mat-option>
          <mat-option value="inactive">Inactive</mat-option>
        </mat-select>
      </mat-form-field>
    </div>

    <div class="min-w-[180px]">
      <button mat-raised-button color="primary" [routerLink]="'/home/master/add-material'" class="w-full h-12 flex items-center justify-center">
        <mat-icon>add</mat-icon>
        <span class="ml-2 font-medium">Add Material</span>
      </button>
    </div>
  </div> -->
       
<div class="w-full pr-10 flex flex-col gap-6 overflow-hidden">
  <form >
    <div class="bg-white rounded-xl p-4 flex items-center gap-4">
      <div class="flex items-center gap-2 w-full">
        <img src="../../assets/image/search.svg" alt="" class="" />
        <input
          placeholder="Search Concern Type  Here..."
          class="w-full border p-2 rounded-md outline-none"
          
          placeholder="Search Service"  matInput (keyup)="applyFilter($event)"
        />
      </div>
      <div class="w-80">
        <select style="background: #4d4de6;"
          class="w-full p-2 outline-none bg-gradient-to-r from-primary to-semiPrimary border rounded-md text-white"
        
         (change)="onStatusChange($event)"
        >

        
        <option value="">All</option>
        <option value="active">Active</option>
        <option value="inactive">Inactive</option>
        </select>
      </div>
     
      <div class="w-60" >
        <app-primary-button [routerLink]="'/home/add-material'" class="flex w-40">
          <div class="flex space-x-2">
            <img src="../../../../assets/image/+.svg" alt="" />
            <span>Add Material</span>
          </div>
        </app-primary-button>
      </div>
    </div>
  </form>

  <!-- Table Section -->
  <div class="bg-white rounded-xl shadow p-4">
    <table mat-table [dataSource]="dataSource" matSort class="mat-elevation-z1 w-full text-sm">

      <!-- S.No -->
      <ng-container matColumnDef="srNo">
        <th mat-header-cell *matHeaderCellDef>#</th>
        <td mat-cell *matCellDef="let row; let i = index">{{ i + 1 }}</td>
      </ng-container>

      <!-- typeOfRoad -->
      <ng-container matColumnDef="typeOfRoad">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Type Of Road</th>
        <td mat-cell *matCellDef="let user">{{ user.typeOfRoad }}</td>
      </ng-container>

      <!-- constructionSteps -->
      <ng-container matColumnDef="constructionSteps">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Construction Steps</th>
        <td mat-cell *matCellDef="let user">{{ user.constructionSteps }}</td>
      </ng-container>

      <!-- materialsNeeded -->
      <ng-container matColumnDef="materialsNeeded">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Materials Needed</th>
        <td mat-cell *matCellDef="let user">{{ user.materialsNeeded }}</td>
      </ng-container>

      <!-- machinesEquipment -->
      <ng-container matColumnDef="machinesEquipment">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Machines Equipment</th>
        <td mat-cell *matCellDef="let user">{{ user.machinesEquipment }}</td>
      </ng-container>


      <!-- Header & Row -->
      <tr mat-header-row *matHeaderRowDef="displayedColumns" class="bg-gray-100 text-gray-700 font-semibold"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns;" class="hover:bg-gray-50"></tr>
    </table>

    <!-- Paginator -->
    <mat-paginator
      [pageSize]="10"
      [pageSizeOptions]="[5, 10, 20]"
      showFirstLastButtons
      class="mt-4"
    ></mat-paginator>
  </div>
</div>
